<template>
  <v-form
    ref="form"
    v-model="valid">
    <v-text-field
      ref="formMyCif"
      v-model="myCif"
      :rules="rules.cif"
      filled
      readonly
      rounded
      dense
      :label="$t('My NIF/CIF')"
      name="cif"
      prepend-inner-icon="mdi-account"
      background-color="grey"
      type="text"
      :disabled="!canEdit"
    />
    <v-select
      v-model="otherSelectedUser"
      rounded
      dense
      prepend-inner-icon="mdi-account"
      filled
      :disabled="!canEdit"
      :background-color="editableColor"
      :placeholder="'Partner NIF/CIF, Mail & Name'"
      :items="usersName"
      @change="onChange(otherSelectedUser)"
    />
    <v-btn text color="#00E5FF" :disabled="!canEdit" @click="modalContact = true">
      {{ $t('+ Add Contact') }}
    </v-btn>
    <v-dialog
      ref="dialog"
      v-model="modalContact"
      width="320px">
      <v-form v-model="valid2" style="background-color: white;">
        <v-text-field
          v-model="contactName"
          :label="$t('Formulary.ContactName')"
          append-icon="mdi-account"
          style="margin-left: 20px; margin-right: 20px; width: 280px;"
          :rules="rules.name"
        />

        <v-text-field
          v-model="contactNIF"
          :label="$t('Contact NIF/CIF')"
          append-icon="mdi-passport"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.cif"
        />
        <v-text-field
          v-model="contactEmail"
          :label="$t('Contact Email')"
          append-icon="mdi-email"
          style="margin-left: 20px; margin-right: 20px; width: 280px"
          :rules="rules.email"
        />
        <v-btn :disabled="!valid2" style="margin-left: 90px" text color="#00E5FF" @click="addContact()">
          {{ $t('+ Add Contact') }}
        </v-btn>
      </v-form>
    </v-dialog>
    <v-text-field
      ref="formValue"
      v-model="value"
      :rules="rules.value"
      :label="$t('AMOUNT')"
      name="value"
      :readonly="inProces"
      :background-color="editableColor"
      type="number"
      filled
      rounded
      dense
      prepend-inner-icon="mdi-cash"
      :disabled="!canEdit"
      @change="calculateComissions"
    />
    <v-text-field
      ref="formAmount"
      v-model="outstandingAmount"
      :rules="rules.value"
      :label="$t('OUTSTANDING AMOUNT')"
      name="value"
      type="number"
      background-color="grey"
      :readonly="true"
      filled
      rounded
      dense
      prepend-inner-icon="mdi-cash"
      @change="calculateComissions"
    />

    <v-text-field
      ref="formNumber"
      v-model="number"
      :label="$t('INVOICE NUMBER')"
      name="number"
      :readonly="inProces"
      :background-color="editableColor"
      filled
      rounded
      dense
      type="text"
      :disabled="!canEdit"
      prepend-inner-icon="mdi-numeric"
    />
    <v-text-field
      ref="formAccountNumber"
      v-model="accountNumber"
      :label="$t('ACCOUNT NUMBER')"
      :rules="rules.iban"
      name="number"
      :readonly="inProces"
      :background-color="editableColor"
      filled
      rounded
      dense
      type="text"
      :disabled="!canEdit"
      prepend-inner-icon="mdi-format-color-text"
    />
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="date"
          :label="$t('DATE')"
          filled
          rounded
          dense
          :disabled="!canEdit"
          prepend-inner-icon="mdi-calendar-blank"
          v-on="on"
        />
      </template>
      <v-date-picker v-model="date" scrollable>
        <v-spacer />
        <v-btn text color="#FF6961" @click="modal = false">
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(date)">
          {{ $t('OK') }}
        </v-btn>
      </v-date-picker>
    </v-dialog>
    <v-dialog
      ref="dialogPayment"
      v-model="modalPayment"
      :return-value.sync="dueDate"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dueDate"
          :label="$t('Due Date')"
          :rules="rules.date"
          filled
          rounded
          dense
          :disabled="!canEdit"
          prepend-inner-icon="mdi-calendar-blank"
          v-on="on"
        />
      </template>
      <v-date-picker v-model="dueDate" scrollable>
        <v-spacer />
        <v-btn text color="#FF6961" @click="modalPayment = false">
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn text color="primary" @click="$refs.dialogPayment.save(dueDate)">
          {{ $t('OK') }}
        </v-btn>
      </v-date-picker>
    </v-dialog>

    <v-radio-group v-if="invoice===null" v-model="radios" row class="justify-center">
      <v-radio :label="$t('Formulary.SENT (to collect)')" value="0" color="primary" />
      <v-radio :label="$t('Formulary.RECEIVED (to pay)')" value="1" color="primary" />
    </v-radio-group>
    <v-card-actions class="justify-center">
      <v-btn v-if="$user" x-large class="justify-center btn-primary white--text" :disabled="!canEdit" @click="savingInvoice()">
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import Constants from "../../../constants";
import ApiRepository from "../../repositories/ApiRepository";
import moment from "moment";

export default {
    name: "Formulary",
    props: {
        invoice: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            usersList: [],
            usersName: [],
            contactUser: null,
            contactNIF: '',
            contactName: '',
            contactEmail: '',
            myCif: '',
            accountNumber: '',
            otherSelectedUser: '',
            value: '',
            inProces: false,
            editableColor: 'none',
            number: '',
            modalContact: null,
            outstandingAmount: '',
            date: null,
            stars: 0,
            files: [],
            colorEditableMail: 'none',
            invoiceFiles: [],
            valid: false,
            valid2: false,
            radios: null,
            rules: {
                cif: [
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || v === '' || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'),
                ],
                comission: [
                    v => (!isNaN(parseFloat(v)) && v >= 0) || this.$t('Comission must be greater than 0')
                ],
                iban: [
                    v => !v || /([A-Z]{2})\s*\t*(\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d)\s*\t*(\d\d\d\d\d\d\d\d\d\d)/.test(v) ||  this.$t('The account number (IBAN) is invalid!')
                ],
                email: [
                    v => /.+@.+\..+/.test(v) || v === '' || this.$t('The mail must be valid.')
                ],
                value: [
                ],
                date: [
                ],
            },
            dialog: false,
            modal: null,
            dueDate: null,
            modalPayment: null,
            factor: false,
            factorComission: 0,
            payerComission: 0,
            readonly: false,
            factoring: {type: Object, default: null},
            canEdit: true,
            canEditEmail: true,
            iAmPayer: false
        };
    },
    computed: {
    },
    created () {
        if (this.invoice !== null) {
            this.new(this.invoice);
            if (this.invoice.relatedFactoring) {
                this.getInvoiceFactoring();
            }
            this.getUsers();
        } else this.new(null);
    },
    methods: {
        new (data) {
            this.initForm();
            if (data.payer && this.$user && this.$user.cif === data.payer.cif) { //jo soc el pagador (payer)
                this.myCif = this.$user.cif;
                if (data.receiver && data.receiver.cif) {
                    this.contactNIF = data.receiver.cif;
                }
                if (data.receiver && data.receiver.email) {
                    this.contactEmail = data.receiver.email;
                }
                if (!data.receiver || (data.receiver && !data.receiver.registered)) {
                    this.canEditEmail = true;
                } else {
                    this.canEditEmail = false;
                }
                this.iAmPayer = true;
            } else { //jo soc el receptor (reciever)
                this.myCif = data.receiver.cif;
                if (data.payer && data.payer.cif) {
                    this.contactNIF = data.payer.cif;
                }
                if (data.payer && data.payer.email) {
                    this.contactEmail = data.payer.email;
                }
                if (!data.payer || (data.payer && !data.payer.registered)) {
                    this.canEditEmail = true;
                } else {
                    this.canEditEmail = false;
                }
                this.iAmPayer = false;
            }
            if (data !== null && data !== undefined) {
                data.date ? this.date = moment(data.date).format("YYYY-MM-DD").substr(0, 10) : "";
                data.dueDate ? this.dueDate = moment(data.dueDate).format("YYYY-MM-DD").substr(0, 10) : "";
                data.amount ? this.value = data.amount.toString() : "";
                data.outstandingAmmount || data.outstandingAmmount === 0 ? this.outstandingAmount = data.outstandingAmmount : "";
                this.number = data.number;
                this.accountNumber = data.accountNumber;
                if (this.myCif) this.myCif = this.myCif.toUpperCase();
                if (this.contactNIF) this.contactNIF = this.contactNIF.toUpperCase();
                if (this.value === '' || this.outstandingAmount === '') this.inProces = false;
                else this.inProces = parseInt(this.value) !== parseInt(this.outstandingAmount);
                this.editableColor = this.inProces ? 'grey' : 'none';
                this.colorEditableMail = this.canEditEmail ? 'none' : 'grey';
            }
            if (data.rossumStatus === Constants.ROSSUM.STATUS_SCANNED &&  data.rossumCollectedInfo) {
                let detectedFields = this.$t('Rossum have detected the next information:');
                let openModal = false;
                if (!this.iAmPayer && data.rossumCollectedInfo.payerCif && !this.contactNIF) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Other cif: ') + "</b>" + data.rossumCollectedInfo.payerCif;
                    openModal = true;
                }
                if (this.iAmPayer && data.rossumCollectedInfo.receiverCif && !this.contactNIF) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Other cif: ') + "</b>" + data.rossumCollectedInfo.receiverCif;
                    openModal = true;
                }
                if (data.rossumCollectedInfo.amount && !this.value) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Amount: ') + "</b>" + data.rossumCollectedInfo.amount;
                    openModal = true;
                }
                if (data.rossumCollectedInfo.number && !this.number) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Number: ') + "</b>" + data.rossumCollectedInfo.number;
                    openModal = true;
                }
                if (data.rossumCollectedInfo.accountNumber && !this.accountNumber) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Account number: ') + "</b>" + data.rossumCollectedInfo.accountNumber;
                    openModal = true;
                }
                detectedFields += "<br>";
                detectedFields += this.$t('Do you want to import?(in the next screen you can modify the fields)');
                if (openModal) {
                    this.$root.$emit('show-confirmation-modal', {
                        title: this.$t('Import information?'),
                        message: detectedFields,
                        oneButton: false,
                        yes: () => {
                            if (!this.iAmPayer && data.rossumCollectedInfo.payerCif && !this.contactNIF) {
                                this.contactNIF = data.rossumCollectedInfo.payerCif;
                                this.searchEmail(this.contactNIF);
                            }
                            if (this.iAmPayer && data.rossumCollectedInfo.receiverCif && !this.contactNIF) {
                                this.contactNIF = data.rossumCollectedInfo.receiverCif;
                                this.searchEmail(this.contactNIF);
                            }
                            if (data.rossumCollectedInfo.amount && !this.value) {
                                this.value = data.rossumCollectedInfo.amount;
                            }
                            if (data.rossumCollectedInfo.number && !this.number) {
                                this.number = data.rossumCollectedInfo.number;
                            }
                            if (data.rossumCollectedInfo.accountNumber && !this.accountNumber) {
                                this.accountNumber = data.rossumCollectedInfo.accountNumber;
                            }
                        },
                        no: () => {
                        }
                    });
                }
            }
        },
        onClose () {
            this.$emit('close');
            this.resetForm();
        },
        resetForm () {
            this.$refs.form.reset();
            this.$nextTick(() => {
                this.initForm();
            });
        },
        initForm () {
            this.radios = '0';
        },
        searchEmail (cif) {
            ApiRepository.getUserByCif(cif)
                .then((res) => {
                    if (res.data.email !== "") {
                        this.contactEmail = res.data.email;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        calculateComissions () {
            ApiRepository.getFactorComission()
                .then((res) => {
                    this.factorComission = this.value * res.data.factorComission;
                    this.factorComission = this.factorComission.toFixed(2);
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                        missatge = this.$t('ERROR: Something went wrong');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                        missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                    this.$emit('error');
                    //this.onClose();
                    console.error(err);
                });
            ApiRepository.getPayerComission()
                .then((response) => {
                    this.payerComission = this.value * response.data.payerComission;
                    this.payerComission = this.payerComission.toFixed(2);
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                        missatge = this.$t('ERROR: Something went wrong');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                        missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                    this.$emit('error');
                    //this.onClose();
                    console.error(err);
                });
        },
        getInvoiceFactoring () {
            ApiRepository.getFactoringById(this.invoice.relatedFactoring)
                .then((res) => {
                    this.factoring = res.data.factoring;
                    if (this.factoring.status !== Constants.FACTORING.STATUS_DISCARDED && this.factoring.status !== Constants.FACTORING.STATUS_REJECTED) {
                        this.canEdit = false;
                    }
                })
                .catch((err) => {
                    this.$emit('error');
                    console.error(err);
                });
        },
        savingInvoice () {
            if (this.invoice !== null) this.updatingInvoice();
            else this.saveInvoice();
        },
        async saveInvoice () {
            let type;
            const radios = this.radios;
            if (this.radios === '0') type = Constants.INVOICE.TYPE_SENT;
            else type = Constants.INVOICE.TYPE_RECEIVED;
            const errorFiles = await this.saveFiles();
            const cif = this.myCif;
            const otherCif = this.contactNIF;
            const value = this.$data.value;
            const date = this.$data.date;
            const dueDate = this.$data.dueDate;
            const number = this.$data.number;
            const invoiceFiles = this.invoiceFiles;
            const factor = this.factor;
            const factorComission = this.factorComission;
            const payerComission = this.payerComission;
            const stars = this.stars;
            const accountNumber = this.accountNumber;
            if (!errorFiles) {
                if ((factor && radios !== '1') || (!factor)) {
                    ApiRepository.uploadInvoice(cif, otherCif, value, type, date, number, invoiceFiles, factor, factorComission, payerComission, stars, accountNumber, dueDate)
                        .then(() => {
                            this.$root.$emit('show-snackbar', {message: "Saved successfully!"});
                            this.$emit('refresh');
                        })
                        .catch((err) => {
                            let missatge = "";
                            if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                                missatge = this.$t('ERROR: Invoice number already exists');
                            } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                                missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                            }
                            this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                            this.$emit('error');
                            console.error(err);
                        });
                } else {
                    this.$root.$emit('show-snackbar', {message: this.$t('Formulary.You cannot post an invoice where you have to pay'), color: 'error'});
                    this.$emit('error');
                }
            }
        },
        async updatingInvoice () {
            const cif = this.myCif;
            const otherCif = this.contactNIF;
            await ApiRepository.updateInvoice(this.invoice._id, cif, otherCif, this.number, this.contactEmail, this.date, this.dueDate, this.accountNumber)
                .then(() => {
                    this.$emit('refresh');
                }).catch((err) => {
                    let message;
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_NUMBER_INVOICE)
                        message = this.$t('The invoice number you have entered already exists');
                    else if (err.response.data.errorCode === Constants.ERRORS.ERROR_INVOICE_NOT_EDITABLE)
                        message = this.$t('InvoiceView.ERROR: Non-editable invoice');
                    this.$root.$emit('show-snackbar', {message: message, color: 'error'});
                    this.$emit('error');
                    console.error(err);
                });
        },
        async saveFiles () {
            let error = false;
            await ApiRepository.saveFiles(this.files)
                .then(() => {
                    for (let i = 0; i < this.files.length; i++) {
                        this.invoiceFiles[i] = {originalName: this.files[i].name};
                    }
                })
                .catch((err) => {
                    error = true;
                    console.log(err.response.data.error);
                    this.$root.$emit('show-snackbar', {message: err.response.data.error, color: 'error'});
                    this.$emit('error');
                });

            return error;
        },
        onChange (value) {
            const cif_other = value.split(', ');
            this.contactEmail = cif_other[2];
            this.contactNIF = cif_other[1];
            this.contactName = cif_other[0];
        },
        async addContact () {
            let contactNameExists = false;
            let contactNIFExists = false;
            let contactEmailExists = false;
            console.log(this.contactName);
            console.log(this.contactNIF);
            console.log(this.contactEmail);
            console.log(this.usersList);

            for (const user of this.usersList) {
                if (user.name === this.contactName) contactNameExists = true;
                if (user.cif === this.contactNIF) contactNIFExists = true;
                if (user.email === this.contactEmail) contactEmailExists = true;
            }

            if (contactNameExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Name duplicated'), color: "error"});
            } else if (contactNIFExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('NIF duplicated'), color: "error"});
            } else if (contactEmailExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Email duplicated'), color: "error"});
            } else {
                const contact = {
                    cif: this.contactNIF,
                    name: this.contactName,
                    email: this.contactEmail
                };
                await ApiRepository.addContact(this.$user.cif, contact).then(() => {
                    this.modalContact = false;
                    this.$root.$emit('show-snackbar', {message: this.$t('Contact added successfully!'), color: "success"});
                    this.getUsers();
                });
            }
        },
        getUserByCif (cif) {
            for (const user of this.usersList) {
                if (user.cif.toLowerCase() === cif.toLowerCase()) {
                    this.contactUser = user;
                    this.otherSelectedUser = user.name + ", " + user.cif + ", " + user.email;
                }
            }
        },
        async getUsers () {
            await ApiRepository.getContacts(this.$user.cif).then((res) => {
                this.usersList = res.data.contacts;
                this.usersName = [];
                for (const user of this.usersList) {
                    this.usersName.push(user.name + ", " + user.cif + ", " + user.email);
                }
                this.getUserByCif(this.contactNIF);
            })
                .catch((err) => {
                    console.log("ERROR: " + err);
                });
        },
    },
};
</script>

<style scoped>

</style>
